import React, { useState, useEffect } from "react";
import { View, Text, TouchableOpacity, Image, ScrollView, Dimensions } from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
import api from "../../services/api";

import HeaderDefault from "../../components/HeaderDefault";
import ScreenLoader from '../../components/ScreenLoader'

import styles from "./style";

const width = Dimensions.get('screen').width;

export default function Marketplace({ navigation }) {
  const [actives, setActives] = useState([]);
  const [loading1, setLoading1] = useState(false);  
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(-1);


  useEffect(() => {
    getActives();
  }, []);

  useEffect(() => {
    if(actives.length > 0) {
      let subc = [{id: -1, name: 'Todos'}];
      actives.map((el) => {
        let subOfActive = el.subcategories;
        subOfActive.map((item) => {
          if(subc.indexOf(item) === -1) {
            subc.push(item);
          }
        })
      });
      setSubcategories(subc);
    }
  }, [actives]);

  const getActives = async () => {
    const token = await AsyncStorage.getItem('JWT_TOKEN');
    const idActive = await AsyncStorage.getItem('id_category');
    setLoading1(true)
    api.get(`/actives/getActives/${idActive}`, { headers: { 'Authorization': `Basic ${token}` } })
      .then((res) => {
        var arrActives = [];
        res.data.active.map(item => {
          arrActives.push(item);
        });
        setLoading1(false)
        setActives(arrActives);
      })
      .catch((error) => {
        setLoading1(false)
        console.log(error);
      })
  }

  const selectedToken = async (id) => {
    await AsyncStorage.setItem("id_token", id.toString());

    navigation.navigate('DetailsCoin')
  }

  return (
    <View style={styles.container}>
      <ScreenLoader loading={loading1} />
      <HeaderDefault title={"MARKETPLACE"} />

      <View style={styles.header}>
        <Text style={styles.header_text}>Tokens disponíveis</Text>
      </View>

      <ScrollView style={styles.assets_list}>

        <View style={{flex: 1, marginBottom: 10, padding: 10, paddingTop: 0, display: 'flex', flexDirection: 'row', width: width-30}}>
          {
            subcategories.map((el, index) => <TouchableOpacity key={index} onPress={() => {setSelectedSubcategory(el.id)}} style={{backgroundColor: (el.id !== selectedSubcategory ? '#999' : '#333'), padding: 5, paddingHorizontal: 15, height: 36, borderRadius: 18, margin: 5}}>
              <Text style={{color: '#FFFFFF', fontWeight: '700', lineHeight: 26, fontSize: 16}}>{el.name}</Text>
            </TouchableOpacity>)
          }
        </View>

        <View style={{flex: 1, flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start', width: width-30}}>
          {actives.map((item) => {
            let subcategoryFilterMatch = false;
            if(!selectedSubcategory || selectedSubcategory === -1)
              subcategoryFilterMatch = true;
            let subcategoriesOfEl = item.subcategories;
            subcategoriesOfEl.map((el) => {
              if(el.id === selectedSubcategory) {
                subcategoryFilterMatch = true;
              }
            });
            if(subcategoryFilterMatch) {
              return (
                <TouchableOpacity
                  key={item.id}
                  onPress={() => selectedToken(item.id)}
                  style={styles.asset}
                >
                  <View >
                    <Image source={{ uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}` }} style={styles.asset_icon} />
                    <Text numberOfLines={2} style={styles.asset_name}>{item.name_token}</Text>
                  </View>
                </TouchableOpacity>
              );
            }
            return (<></>);
          })}
        </View>

      </ScrollView>
    </View>
  );
}
